module.exports = __webpack_public_path__ + "static/media/PlayfairDisplay-SemiBold.0a83765b.woff2";